import debounce from 'lodash.debounce';

import { isInViewport } from './utils';

function initGalleryAnimation(gallery) {

  const even = gallery.classList.contains('even');

  const slides = gallery.querySelectorAll('.gallery__slide');
  slides.forEach((slide, i) => {
    slide.style.transform = `translateX(${even ? '-' : ''}${150 * i}%)`;
    slide.style.transitionDelay = `${.15 * i}s`;
  });

  const flickityViewport = gallery.querySelector('.flickity-viewport');
  
  const testGalleryInViewport = () => {
    if (isInViewport(gallery)) {
      gallery.classList.add('in');
    }
  };

  window.addEventListener('scroll', debounce(testGalleryInViewport));
}


export default initGalleryAnimation;